import { render, staticRenderFns } from "./CommodityImageDialog.vue?vue&type=template&id=c312adb6&scoped=true&"
import script from "./CommodityImageDialog.vue?vue&type=script&lang=js&"
export * from "./CommodityImageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c312adb6",
  null
  
)

export default component.exports